<div class="file-info-header" *ngIf="currentFile">
  <!-- Navigation Controls Row -->
  <div class="header-navigation" *ngIf="_files && _files.length">
    <div class="navigation-controls">
      <button
        [disabled]="index === 0"
        class="btn btn-link nav-button nav-button-left"
        (click)="prev()"
      >
        <i class="fa fa-chevron-left"></i>
      </button>
      <span class="file-counter"> {{ index + 1 }} / {{ _files.length }} </span>
      <button
        [disabled]="index === _files.length - 1"
        class="btn btn-link nav-button nav-button-right"
        (click)="next()"
      >
        <i class="fa fa-chevron-right"></i>
      </button>
    </div>
    <div class="header-actions">
      <!-- PDF Zoom Controls -->
      <div class="zoom-controls" *ngIf="fileType('pdf')">
        <button
          class="btn btn-link nav-button"
          (click)="zoomOut()"
          [disabled]="zoomLevel <= minZoom"
          title="Zoom out"
        >
          <i class="fa fa-search-minus"></i>
        </button>
        <span class="zoom-level">{{ getZoomPercentage() }}%</span>
        <button
          class="btn btn-link nav-button"
          (click)="zoomIn()"
          [disabled]="zoomLevel >= maxZoom"
          title="Zoom in"
        >
          <i class="fa fa-search-plus"></i>
        </button>
        <button class="btn btn-link nav-button" (click)="fitToPage()" title="Fit to page">
          <i class="fa fa-arrows-alt"></i>
        </button>
      </div>
      <button
        *ngIf="currentFile?.id"
        class="btn btn-link nav-button"
        (click)="open()"
        title="Open file in new window"
      >
        <i class="fa fa-external-link"></i>
      </button>
    </div>
  </div>
  <!-- File Name and Type Row -->
  <div class="file-name-row">
    <div class="file-name">
      <i
        class="fa"
        [ngClass]="{
          'fa-file-pdf-o': currentFile.type === 'application/pdf',
          'fa-file-image-o': currentFile.type?.includes('image/'),
          'fa-file-word-o':
            currentFile.type?.includes('word') ||
            currentFile.type?.includes('msword') ||
            currentFile.type?.includes('wordprocessingml'),
          'fa-file-excel-o':
            currentFile.type?.includes('excel') || currentFile.type?.includes('spreadsheet'),
          'fa-file-powerpoint-o':
            currentFile.type?.includes('powerpoint') || currentFile.type?.includes('presentation'),
          'fa-file-archive-o':
            currentFile.type?.includes('zip') || currentFile.type?.includes('rar'),
          'fa-file-text-o': currentFile.type?.includes('text/plain'),
          'fa-file-code-o': currentFile.type?.includes('json') || currentFile.type?.includes('xml'),
          'fa-file-o':
            !currentFile.type?.includes('pdf') &&
            !currentFile.type?.includes('image') &&
            !currentFile.type?.includes('word') &&
            !currentFile.type?.includes('excel') &&
            !currentFile.type?.includes('powerpoint') &&
            !currentFile.type?.includes('zip') &&
            !currentFile.type?.includes('rar') &&
            !currentFile.type?.includes('text') &&
            !currentFile.type?.includes('json') &&
            !currentFile.type?.includes('xml')
        }"
        aria-hidden="true"
      ></i>
      <span class="file-name-text">{{
        currentFile.originalName || currentFile.originalFileName || currentFile.name || currentFile.fileName || "Unknown File"
      }}</span>
    </div>
    <span class="file-date" *ngIf="currentFile.dateCreatedUtc">
      <i class="fa fa-calendar" aria-hidden="true"></i>
      {{ currentFile.dateCreatedUtc | date : "MM/dd/yyyy" }}
    </span>
  </div>

  <!-- File Details Row (removed since date is now in the name row) -->
</div>

<div class="file-preview-container">
  <div *ngIf="currentFile && !currentFile.id">
    <div *ngIf="src">
      <pdf-viewer
        [src]="src"
        [autoresize]="true"
        [original-size]="false"
        [zoom]="zoomLevel"
        class="documentWireframe"
        *ngIf="currentFile.type === 'application/pdf'"
      >
      </pdf-viewer>
      <img
        #img
        [appGetFile]="src"
        [appPreviewFile]="true"
        *ngIf="currentFile.type?.includes('image/')"
        class="imagePreviews"
      />
    </div>
  </div>

  <div *ngIf="currentFile && currentFile.id">
    <div>
      <pdf-viewer
        [src]="src"
        [autoresize]="true"
        [original-size]="false"
        [zoom]="zoomLevel"
        class="documentWireframe"
        *ngIf="fileType('pdf')"
      >
      </pdf-viewer>
      <img
        #img
        [appGetFile]="src"
        [appPreviewFile]="true"
        *ngIf="fileType('jpeg')"
        class="imagePreviews"
      />
    </div>
  </div>
</div>
